import styles from './LoginPage.module.css';
import BrandPanel from '../components/login/BrandPanel';
import SignupForm from '../components/login/SignupForm';

const SignupPage = () => {
  return (
    <div className={styles.page}>
      {/* Left Column */}
      <div className={styles.leftCol}>
        <BrandPanel />
      </div>

      {/* Right Column */}
      <div className={styles.rightCol}>
        <SignupForm />
      </div>
    </div>
  );
};

export default SignupPage;
